module.exports = __webpack_public_path__ + "static/merino-shoe-36519b49d1dacec63f7c3557066d9584.png";